import { getState } from 'helpers';

export const getApplicationStep = () => {
  const { app } = getState();
  return app.step || '';
};

